var map = {
	"./avtoaksessuary.svg": "8463",
	"./default.svg": "58ac",
	"./elektro-i-benzoinstrument.svg": "9527",
	"./gazosvarochnoe-oborudovanie.svg": "1032",
	"./gidravlicheskij-i-silovoj-instrument.svg": "c02e",
	"./himija.svg": "637c",
	"./hranenie-instrumenta-i-mebel'.svg": "158b",
	"./instrument-dlja-metalloobrabotki.svg": "8057",
	"./instrument-milwaukee.svg": "2295",
	"./inventar'.svg": "7194",
	"./iskrobezopasnyj-instrument.svg": "2d8a",
	"./maljarno-kuzovnoe-oborudovanie.svg": "1564",
	"./merch.svg": "6c9e",
	"./oborudovanie-dlja-sklada.svg": "e762",
	"./oborudovanie-dlja-sto.svg": "4a31",
	"./osveschenie.svg": "f5fd",
	"./pnevmoinstrument.svg": "ff1a",
	"./pusko-zarjadnye-ustrojstva.svg": "ff0a",
	"./rashodnye-materialy.svg": "1b77",
	"./ruchnoj-instrument.svg": "2d65",
	"./shinomontazhnyj-uchastok.svg": "563b",
	"./spetsial'nyj-instrument.svg": "9aba",
	"./sredstva-izmerenij.svg": "614a",
	"./stationery/bumaga-i-prisposoblenija-dlja-cherchenija.svg": "de76",
	"./stationery/bumazhnaja-produktsija.svg": "738e4",
	"./stationery/doski-i-aksessuary-k-nim.svg": "9a47",
	"./stationery/kantseljarija-i-ofisnye-prinadlezhnosti.svg": "a23c",
	"./stationery/karandashi.svg": "b24b",
	"./stationery/lastiki.svg": "70b3",
	"./stationery/linejki.svg": "1c82",
	"./stationery/markery.svg": "dc20",
	"./stationery/mel-dlja-doski.svg": "5591",
	"./stationery/ruchki.svg": "ffcf",
	"./stationery/shtempel'naja-produktsija.svg": "f752",
	"./stationery/tetradi.svg": "7133",
	"./stationery/tochilki.svg": "149d",
	"./svarochnoe-oborudovanie.svg": "7470"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0043";